import jsPDF from "jspdf";
import Map from "ol/Map";
import { View } from "ol";
import VectorLayer from "ol/layer/Vector";
import { getLabelStyle, getLineStyle, getPrintGraveStyle } from "./common/styles";
import { IPrintingData, IPrintingLabels } from "./common/interfaces";
import logo from "./img/logo.png";
import { getLocalizedText } from "./common/translations";

declare var CintorinFonts: {
    fontData:any
}

const DPI = 96;
const WIDTH_MM = 297; // A4 
const HEIGHT_MM = 210; // A4 
const WIDTH_PX = (WIDTH_MM / 25.6) * DPI; 
const HEIGHT_PX = (HEIGHT_MM / 25.6) * DPI;
const PAGE_MARGIN = 10;

export function print(sourceView: View, printingData :IPrintingData, labels :IPrintingLabels) {
    if (!printingData)
        return;
    const pdf = new jsPDF("l", "mm");
    pdf.addFileToVFS("Roboto-Regular.ttf", CintorinFonts.fontData);
    pdf.addFont("Roboto-Regular.ttf", "Roboto", "normal");
    pdf.setFont("Roboto");
    pdf.setDrawColor("#000000");
    pdf.addImage(logo, "PNG", PAGE_MARGIN, PAGE_MARGIN, pxToMm(210), pxToMm(82));
    let xOffset = PAGE_MARGIN + pxToMm(210) + 3;
    let textBoxWidth = WIDTH_MM - xOffset - PAGE_MARGIN;
    let textBoxHeight = pxToMm(82);

    let cellHeight = textBoxHeight / 3;
    let cellWidth = textBoxWidth / 2;
    let baseFontSize = cellHeight * 72 / 25.6; // 1pt = 1/72in = 25.6/72mm
    pdf.setFontSize(baseFontSize * 0.90); // 95% scale kvoli presahom
    pdf.text(getLocalizedText("printCityLabel")+labels.cityName, xOffset, PAGE_MARGIN + cellHeight);
    pdf.text(getLocalizedText("printCemeteryLabel")+labels.cemeteryName, xOffset, PAGE_MARGIN + 2*cellHeight);
    pdf.text(getLocalizedText("printCreatedBy")+"TOPSET, Stupava", xOffset + cellWidth, PAGE_MARGIN + cellHeight);
    pdf.setFontSize(baseFontSize * 0.75);
    pdf.text(getLocalizedText("printLastModifiedLabel")+labels.lastUpdate, xOffset + cellWidth, PAGE_MARGIN + 2*cellHeight);
    pdf.setFontSize(baseFontSize * 0.60);
    pdf.text(getLocalizedText("printLastModifiedExplanation"), xOffset + cellWidth, PAGE_MARGIN + 3*cellHeight);

    let container = document.createElement("div");
    container.style.width = "1px";
    container.style.height = "1px";
    let mapContainer = document.createElement("div");
    mapContainer.style.width = WIDTH_PX+"px";
    mapContainer.style.height = HEIGHT_PX+"px";
    container.appendChild(mapContainer);
    let lineLayer = new VectorLayer({
        source: printingData.lines,
        style: getLineStyle
    });
    let labelLayer = new VectorLayer({
        source: printingData.labels,
        style: getLabelStyle
    });
    let graveLayer = new VectorLayer({
        source: printingData.graves,
        style: getPrintGraveStyle
    })
    let map = new Map({
        layers: [
            lineLayer,
            labelLayer,
            graveLayer
        ],
        view: new View({
            projection: sourceView.getProjection(),
            center: sourceView.getCenter(),
            resolution: sourceView.getResolution(),
            rotation: sourceView.getRotation()
        }),
        target: mapContainer
    });
    map.once("rendercomplete", () => {
        let imageOffset = textBoxHeight + 3 + PAGE_MARGIN;
        Array.prototype.forEach.call(
            map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
            function (canvas:HTMLCanvasElement) {
                pdf.rect(PAGE_MARGIN, imageOffset, WIDTH_MM - 2*PAGE_MARGIN, HEIGHT_MM - imageOffset - PAGE_MARGIN, "S");
                pdf.addImage(canvas, "PNG", PAGE_MARGIN, imageOffset, WIDTH_MM - 2*PAGE_MARGIN, HEIGHT_MM - imageOffset - PAGE_MARGIN);
            }
        );
        pdf.save("mapa.pdf");
        document.getElementsByTagName("body")[0].removeChild(container);
    });
    document.getElementsByTagName("body")[0].appendChild(container);
    map.updateSize();
}

function mmToPx(mmValue:number):number {
    return (mmValue * DPI) / 25.6;
}

function pxToMm(pxValue:number):number {
    return (pxValue * 25.6) / DPI;
}